import defaultState from "./state";


const mantenedorSelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_MANTENEDOR_CUPO": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_CUPO": {
      return Object.assign({}, state, {
        isOpenModalEliminar: action.isOpen,
        cupo: action.cupo,
      });
    }
    case "OPEN_CLOSE_MODAL_DESACTIVAR_CUPO": {
      return Object.assign({}, state, {
        isOpenModalDesactivar: action.isOpen,
        cupo: action.cupo,
      });
    }
    case "SET_LISTA_CUPOS_FILTRADOS": {
      return Object.assign({}, state, {
        listaCuposFiltrados: action.lista,
      });
    }
    case "SET_CUPO": {
      return Object.assign({}, state, {
        cupo: action.cupo,
      });
    }
    case "OPEN_CLOSE_MODAL_EDITAR_CUPO": {
      return Object.assign({}, state, {
        isOpenModalEditar: action.isOpen,
        cupo: action.cupo,
        isNewCupo: action.isNew,
      });
    }
    case "SET_LISTA_CUPOS": {
      return Object.assign({}, state, {
        listaCupos: action.data,
        listaCuposFiltrados: action.data,
      });
    }
    case "SET_FILTROS_CUPOS": {
      return Object.assign({}, state, {
        filtrosCupos: action.filtros,
      });
    }
    default:
      return state;
  }
};
export default mantenedorSelReducer;
